import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
import "./abstract.css";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
          }}
        >
          {" "}
          <img
            style={{ height: 30, width: 70, mixBlendMode: "multiply" }}
            src="images/india.webp"
            alt=""
          />
          &nbsp; Sahyadri Issue 91 &nbsp;
          <img
            style={{ height: 30, width: 70, mixBlendMode: "multiply" }}
            src="images/india.webp"
            alt=""
          />
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "1.5em",
            }}
          >
            <br />
            Plant diversity is the variety of plant species in an area, which
            occurs mainly due to the different characteristics and adaptations
            shown by plants to different environments. The current issue of
            Sahyadri E- news (Issue XCI) documents plant diversity in Kerala,
            including major habits like trees, shrubs and herbs and the district
            wise spatial analysis of species.{" "}
            <Link to="/article">Read More...</Link>
            <br />
            <br />
            <hr />
            <br />
          </p>
          <div
            style={{
              textAlign: "center",
              borderRadius: "30px",
              marginLeft: "30px",
            }}
            className="jumbotron row container"
          >
            <div className="col-3 d-flex justify-content-evenly">
              <img
                style={{ height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/EWRG_logo.jpeg"
              />
              <img
                style={{ height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/IISc_Master_Seal.jpg"
              />
            </div>
            <div className="col-5">
              <p style={{ fontSize: "0.9999999999em", textAlign: "center" }}>
                IISc-EIACP[ENVIS CENTRE],
                <br />
                Energy & Wetlands Research Group[CES TE-15] <br />
              </p>
              <p style={{ fontSize: "0.9em", textAlign: "center" }}>
                Centre for Ecological Sciences,
                <br />
                Indian Institute of Science, Bangalore 560012,INDIA
              </p>
              <p style={{ fontSize: "0.9em", textAlign: "center" }}>
                Email:
                <a
                  href="mailto:tvr@iisc.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  tvr@iisc.ac.in
                </a>
                ,&nbsp;
                <a
                  href="mailto:envis.ces@iisc.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  envis.ces@iisc.ac.in
                </a>
                <br />
                Web:&nbsp;
                <a
                  href="http://wgbis.ces.iisc.ac.in/biodiversity"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://wgbis.ces.iisc.ac.in/biodiversity
                </a>
                ,&nbsp;
                <br />
                <a
                  href="http://wgbis.ces.iisc.ac.in/energy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://wgbis.ces.iisc.ac.in/energy
                </a>
              </p>
            </div>
            <div className="col-3 d-flex justify-content-evenly">
              <img
                style={{ height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/EIACP_Logo.png"
              />
              <img
                style={{ height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/ENVIS Logo_FINAL.png"
              />
            </div>
          </div>
        </div>
      }
    />
  );
}

export default AbstractPage;
